/**
 * Mã trên tem có dạng [tiền tố]<sep>[mã phân cấp]. Hai họ tem:
 *   • Phân cấp bằng GẠCH NGANG, tách tiền-tố bằng "_"  : "SB_03-05-25", "GN_02-14", "BP_07".
 *   • Phân cấp bằng GẠCH DƯỚI, tách tiền-tố bằng "__"  : "000532-27-12-02__07_02" (thư viện BAZIS).
 * Vì designation họ sau CHỨA "_" bên trong, "__" là ranh giới rõ ràng — phải xét TRƯỚC "_" đơn.
 * Trả về phần designation (giữ nguyên "_"/"-" bên trong), hoặc null nếu không nhận ra mã.
 */
export function parsePartCode(text: string): string | null {
  let s = text.trim();
  // Deep-link tem QR (vd https://woodviewer.com/v/{token}?partID=07_02): rút giá trị partID
  // (không phân biệt hoa/thường) rồi phân tích tiếp như tem trần. Nhờ đó scanner in-app quét một
  // URL đầy đủ ra CÙNG kết quả với quét tem trần. URL không có partID → giữ nguyên s (rơi về null).
  const urlParam = s.match(/[?&]partid=([^&#]+)/i);
  if (urlParam) {
    try {
      s = decodeURIComponent(urlParam[1]).trim();
    } catch {
      s = urlParam[1].trim();
    }
  }
  // "__" = ranh giới tiền-tố ↔ designation; cắt ở "__" CUỐI, phần sau phải là mã số (ngăn -/_).
  const dd = s.lastIndexOf('__');
  if (dd >= 0) {
    const tail = s.slice(dd + 2);
    if (/^\d+(?:[-_]\d+)*$/.test(tail)) return tail;
  }
  // QR KHÔNG tiền tố: cả chuỗi là mã số (ngăn "-" hoặc "_") → giữ nguyên, kể cả "07_02".
  if (/^\d+(?:[-_]\d+)*$/.test(s)) return s;
  // Tem "SB_03-05-25": tiền-tố (có chữ) + "_" + designation gạch-ngang → lấy cụm sau "_" cuối.
  const m = s.match(/_(\d+(?:-\d+)*)$/);
  return m ? m[1] : null;
}
